import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import { InfinitySpin } from "react-loader-spinner";
import { PositionLayout } from "../../assets/styles/mainPageStyles";
export var Spinner = memo(function Spinner() {
    return (_jsx(PositionLayout, { position: "fixed", top: "0", left: "0", right: "0", bottom: "0", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000, backgroundColor: "black", children: _jsx(InfinitySpin, { width: "200", color: "#FFB801" }) }));
});
